/* Grondyke: the blend switcher on the home page kit cards.

   The scrolling is the browser's. The track is a scroll snapper, so the swipe on touch and the
   trackpad gesture on desktop both work with no script at all, and this only keeps the labels in
   step with where the track has landed and moves it when one is clicked. Written that way on
   purpose: if the script fails to load the card is still a working, swipeable set of images
   rather than a dead carousel showing one picture.

   A card with a single image renders no controls, so there is nothing here to bind. */
(function () {
  var frames = document.querySelectorAll('[data-gk-kitmedia]');
  if (!frames.length) return;

  Array.prototype.forEach.call(frames, function (frame) {
    var track = frame.querySelector('[data-gk-kittrack]');
    var tabs = frame.querySelectorAll('[data-gk-kitdot]');
    if (!track) return;

    /* Which blend the card arrives on. The markup has already marked the matching label, so this
       only has to move the track under it, with no animation: nobody asked for a card that
       scrolls itself on load. */
    var current = parseInt(track.getAttribute('data-gk-kitstart') || '0', 10);
    if (isNaN(current) || current < 0) current = 0;
    if (current > 0) track.scrollLeft = (track.clientWidth || 0) * current;

    /* A width change makes a pixel offset meaningless, so the card is put back on the blend it
       was showing rather than left halfway between two. */
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        track.scrollLeft = (track.clientWidth || 0) * current;
      }, 150);
    });

    if (tabs.length < 2) return;

    function setActive(i) {
      current = i;
      Array.prototype.forEach.call(tabs, function (tab, j) {
        var on = j === i;
        tab.classList.toggle('is-on', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(tabs, function (tab, i) {
      tab.addEventListener('click', function () {
        var w = track.clientWidth || 0;
        /* Smooth where the shopper has not asked for less motion. The scroll handler below sets
           the active label either way, so this never has to guess where it ended up. */
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        try {
          track.scrollTo({ left: w * i, behavior: reduce ? 'auto' : 'smooth' });
        } catch (e) {
          track.scrollLeft = w * i;
        }
        setActive(i);
      });
    });

    var pending = null;
    track.addEventListener('scroll', function () {
      if (pending) return;
      pending = requestAnimationFrame(function () {
        pending = null;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i < 0) i = 0;
        if (i > tabs.length - 1) i = tabs.length - 1;
        setActive(i);
      });
    }, { passive: true });
  });
})();
